import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThinkpadComponent } from './simple-icons-thinkpad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThinkpadComponent ],
    exports:      [ SimpleIconsThinkpadComponent ],
    bootstrap:    []
})
export class SimpleIconsThinkpadModule {}
